<template>
  <PaymentRealtimeNotificationStack
    v-if="isFinanceUser"
    :items="realtimePaymentAlerts"
    @open="onOpenRealtimeAlert"
    @clear="onClearRealtimeAlerts"
  />
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from "vue";
import PaymentRealtimeNotificationStack from "./PaymentRealtimeNotificationStack.vue";
import { usePaymentRealtimeAlerts } from "../composables/usePaymentRealtimeAlerts";
import UTILS from "@/core/utils";
import { USER_ROLES } from "@/core/enums/USER_ROLES";

defineOptions({
  name: "PaymentRealtimeNotificationStackWrapper",
});

const {
  realtimePaymentAlerts,
  onOpenRealtimeAlert,
  onClearRealtimeAlerts,
  setupPaymentsRealtimeListener,
  teardownPaymentsRealtimeListener,
} = usePaymentRealtimeAlerts();

const isFinanceUser = computed(() => UTILS.isUser(USER_ROLES.FINANCE));

onMounted(() => {
  if (isFinanceUser.value) {
    setupPaymentsRealtimeListener();
  }
});

onBeforeUnmount(() => {
  teardownPaymentsRealtimeListener();
});
</script>
